export const getSET_HIDDEN_COLUMNS = panelIdentifier =>
  panelIdentifier + "_SET_HIDDEN_COLUMNS";
